import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../../_metronic/layout/core'
 import { DealerListWrapper } from '../../master/dealer-management/my-list/DealerListWrapper'

const dealerBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dealer Management',
    path: '/apps/master/dealer-management/dealer',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DealerPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='dealer'
          element={
            <>
              <PageTitle breadcrumbs={dealerBreadcrumbs}>Dealer list</PageTitle>
               <DealerListWrapper /> 
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/master/dealer-management/dealer' />} />
    </Routes>
  )
}
export default DealerPage
